const TABLE = {
  // id: {},
  name: { label: 'App' },
  key: {},
  updated: {},
  created: {},
};

const DIALOG = {
  id: { disabled: true },
  name: { label: 'App', required: true, inline: 2 },
  key: { required: true, inline: 2 },
};

const DIALOG_TABLE = {
  language: { disabled: true },
  value: { style: { flex: 2 } },
};

export default { TABLE, DIALOG, DIALOG_TABLE };
